var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"px-5",attrs:{"fluid":""}},[_c('div',{staticClass:"mt-4 d-flex justify-content-between"},[_c('back-arrow',{attrs:{"title":"Ajouter un propriétaire"}})],1),_vm._v(" "),_c('b-card',{staticClass:"mt-2 mb-4 shadow-sm"},[_c('UserForm',{attrs:{"createHospitalization":_vm.createHospitalization}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64edc681","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/UserCreate.vue
// module id = NbWH
// module chunks = 0